import { render, staticRenderFns } from "./IconTextStriketrough.vue?vue&type=template&id=a5648fec&"
import script from "./IconTextStriketrough.vue?vue&type=script&lang=js&"
export * from "./IconTextStriketrough.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5648fec')) {
      api.createRecord('a5648fec', component.options)
    } else {
      api.reload('a5648fec', component.options)
    }
    module.hot.accept("./IconTextStriketrough.vue?vue&type=template&id=a5648fec&", function () {
      api.rerender('a5648fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextStriketrough.vue"
export default component.exports